import lodash from 'lodash';
import queryString from 'query-string';
import { Platform } from './config-types';
import { RedirectConfig } from './configUrl';

export const urlTransform = (
  /** 当前url/路由 */
  url: string,
  /** 当前平台 */
  sourcePlatform: Platform,
  /** 目标平台 */
  targetPlatform: Platform,
  /** 外部传入的query参数 */
  query?: object,
  /** 当前页面的asPath，动态路由或微前端路由时需传入 */
  asPath?: string,
) => {
  try {
    // 判断是否是子应用路由
    const matches = url.match(/\[([^\]]+)\]/);
    const isMicroApp = matches && matches[1] == '...all';
    const parseUrlObj = queryString.parseUrl(isMicroApp ? asPath : url);

    // 找到匹配的路由配置
    const config = RedirectConfig.find((item) => {
      const sourcePlatformUrl = item?.[`${sourcePlatform}URL`];
      const sourcePlatformDynamicUrl = item?.[`${sourcePlatform}DynamicUrl`];
      const sourcePlatformUrlParams = item?.[`${sourcePlatform}URLParams`];
      const sourcePlatformExtraUrl = item?.[`${sourcePlatform}ExtraUrl`] || [];

      // 当前url 和 配置中的url或动态路由url匹配
      const urlOrDynamicUrlMatched = lodash.some(
        [
          sourcePlatformUrl,
          sourcePlatformDynamicUrl,
          ...sourcePlatformExtraUrl,
        ],
        (urlToMatch) => {
          return urlToMatch === (parseUrlObj.url || '');
        },
      );

      // 如果URL或动态URL不匹配，直接返回false
      if (!urlOrDynamicUrlMatched) {
        return false;
      }

      // 参数匹配，如果参数配置了MatchedUrlFn，则调用此函数根据返回值判断是否匹配
      // 主要是用于多个页面共用一个路由，单纯靠路由不能准确匹配到配置项，因此需要参数辅助匹配的场景
      let queryMatched = true;
      if (sourcePlatformUrlParams) {
        lodash.forEach(sourcePlatformUrlParams, (paramConfig) => {
          const { MatchedUrlFn } = paramConfig;
          if (MatchedUrlFn && lodash.isFunction(MatchedUrlFn)) {
            queryMatched = MatchedUrlFn(lodash.merge(parseUrlObj.query, query));
          }
        });
      }

      return queryMatched;
    });

    if (!config) {
      return '';
    }

    // 提取动态路由参数和query
    let sourceParams = {};

    // 如果url是包含动态路由参数的字符串，使用正则表达式匹配
    if (matches && !isMicroApp) {
      const parts = asPath?.split('/');
      const lastPart = parts?.[parts.length - 1];
      if (lastPart) {
        lodash.set(sourceParams, matches[1], lastPart);
      }
    }

    // 如果parseUrlObj.query存在，合并到sourceParams中
    if (parseUrlObj.query) {
      lodash.merge(sourceParams, parseUrlObj.query);
    }

    // 如果外部传入的query存在，也合并到sourceParams中
    if (query) {
      lodash.merge(sourceParams, query);
    }

    // 生成目标地址 和 参数的处理
    let targetPath = lodash.get(config, `${targetPlatform}URL`);
    const targetURLParams = lodash.get(config, `${targetPlatform}URLParams`);

    if (targetURLParams) {
      let targetParams = {};
      targetURLParams.forEach((item) => {
        const { FixedValue, MapName, ParamsName, DefaultValue, ParamsType } =
          item;
        let value = FixedValue;
        if (!value) {
          // 从sourceParams中获取值
          value = lodash.get(sourceParams, MapName || ParamsName, DefaultValue);
        }
        if (ParamsType === 'query') {
          lodash.set(targetParams, ParamsName, value);
        } else if (ParamsType === 'params') {
          // 将值添加到路径中
          if (targetPath.endsWith('/')) {
            targetPath += value;
          } else {
            targetPath += '/' + value;
          }
        }
      });

      return queryString.stringifyUrl({
        url: targetPath,
        query: targetParams,
      });
    }

    // 目标地址没有参数，直接返回配置的目标地址
    return targetPath;
  } catch (error) {
    return '';
  }
};
